import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const servedeckLogService = {
    getAll,
};

const MODULE = {
    SERVEDECK_LOG: 'servedeck-logs',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            method: filter?.method, // eg. PUT, POST, GET
            action: filter?.action, // auth, delete, create, show
            success: filter?.success, // 1 or 0
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.SERVEDECK_LOG}`, request);
}